import Api from './coreapi';
export default {
    async findById(id){
        return await Api.request().post('sale/quote/find', { Id: id });
    },
    async toOrder(id){
        return await Api.request().post('quote/to-order', { Id: id });
    },
}